import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroBanner() {
  const featured = comics.slice(0, 3);

  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20Korean%20manhwa%20style%20illustration%2C%20epic%20fantasy%20landscape%20with%20floating%20islands%20and%20cherry%20blossoms%2C%20soft%20gradient%20sky%20with%20warm%20orange%20and%20pink%20tones%2C%20Korean%20webtoon%20background%20art%2C%20magical%20atmosphere%2C%20stylized%20illustration%20with%20dynamic%20composition%2C%20sparkling%20particles&width=1600&height=900&seq=hero-bg-korea-comic&orientation=landscape"
        alt="韩国漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            免费韩漫大全，尽在韩国漫画网
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
            海量韩漫资源，每日更新，高清画质，无需注册即可畅享阅读体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>

        {/* Featured Comics */}
        <div className="hidden md:flex items-center gap-6 mt-12">
          {featured.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative w-36 h-48 rounded-lg overflow-hidden border-2 border-white/30 hover:border-white/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              style={{ zIndex: 3 - index }}
            >
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end p-3">
                <span className="text-white text-xs font-medium truncate">{comic.title}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}